import { render } from "./DisplayPanel.vue?vue&type=template&id=32ba5b83&scoped=true"
import script from "./DisplayPanel.vue?vue&type=script&lang=js"
export * from "./DisplayPanel.vue?vue&type=script&lang=js"

import "./DisplayPanel.vue?vue&type=style&index=0&id=32ba5b83&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ba5b83"]])

export default __exports__